<template>
  <div class="footer">
    <div class="flex-column">
      <small class="text">powered by</small>
      <updox-logo qa-id="updoxLogo" />
    </div>
  </div>
</template>

<script>
  import { UpdoxLogo } from "@updox/common-vue";

  export default {
    name: "UpdoxFooter",
    components: {
      UpdoxLogo,
    },
  };
</script>

<style scoped lang="scss">
  .footer {
    margin-top: auto;
    padding: 20px;
    text-align: center;

    .flex-column {
      margin: 0 auto;
      position: relative;
      width: 100px;
    }

    .text {
      font-size: 7px;
      font-weight: 600;
      left: 5px;
      position: absolute;
      top: -6px;
    }
  }
</style>
